import { FC, memo } from 'react';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

import { UIBox } from '@/components/ui/Box';
import { Typography } from '@/components/ui/Typography';
import { useTranslation } from 'react-i18next';

export interface DecodedCounterProps {
  sticky: boolean;
  decodedItemsCount: number;
}

export interface DecodedCounterItemProps {
  $decoded?: boolean;
  $sticky?: boolean;
}

const StyledCounter = styled(UIBox)<{ $sticky?: boolean }>`
  margin-left: 24px;
  ${({ $sticky }): false | FlattenSimpleInterpolation | undefined =>
    $sticky &&
    css`
      && {
        padding: 0;

        h1,
        span {
          color: #fff;
        }

      }
    `}
`;

const StyledCounterItem = styled(UIBox)<DecodedCounterItemProps>`
  flex-direction: column;
  align-items: center;
  padding: 14px 24px;

  ${({ $sticky }): false | FlattenSimpleInterpolation | undefined =>
    $sticky &&
    css`
      flex-direction: row;
      height: 100%;

      && {
        padding: 12px 13px;

        h1 {
          margin: 0 4px 0 8px;
        }

        &::after {
          width: 12px;
          height: 12px;
          border: 1px solid #fff;
        }
      }
    `}

  &:not(:last-of-type) {
    border-right: 1px solid #ededed;
  }

  h1 {
    margin: 8px 0;
  }

  &::after {
    content: '';
    display: block;
    width: 32px;
    height: 8px;
    border-radius: 24px;
    ${({ $decoded }): false | FlattenSimpleInterpolation | undefined =>
      $decoded &&
      css`
        background: #707173;
      `};
  }
`;

export const DecodedCounter: FC<Partial<DecodedCounterProps>> = memo(
  ({
    sticky,
    decodedItemsCount,
  }): JSX.Element => {
    const { t } = useTranslation();

    return (
      <StyledCounter>
        <StyledCounterItem $sticky={sticky} $decoded>
          <Typography
            size={sticky ? `xs` : 'sm'}
            font="heavy"
            color={sticky ? `white` : 'grey'}
          >
            {t('decoded')}
          </Typography>
          <Typography
            size="xl"
            font="heavy"
            as="h1"
            color={sticky ? `white` : 'text'}
          >
            {decodedItemsCount}
          </Typography>
        </StyledCounterItem>
      </StyledCounter>
    );
  }
);

DecodedCounter.displayName = 'DecodedCounter';

export default DecodedCounter;
